import { makeStyles } from '@mui/styles';
import IconButton from 'apollo-react/components/IconButton';
import TextField from 'apollo-react/components/TextField';
import Tooltip from 'apollo-react/components/Tooltip';
import { EllipsisHorizontal } from 'apollo-react-icons';
import Trash from 'apollo-react-icons/Trash';
import React from 'react';

import { getUITA } from '../../../../../utils/commonUtils';

const useStyles = makeStyles({
  field: {
    margin: 0,
  },
  input: {
    overflowX: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
});

export const ActionCell = ({ row }) => {
  const { id, deleteRow } = row;
  return (
    <div style={{ paddingTop: 10 }}>
      <IconButton onClick={() => deleteRow(id)}>
        <Trash />
      </IconButton>
    </div>
  );
};

export const FieldCell = ({ row, column: { accessor: key } }) => {
  const classes = useStyles();

  const { handleOpenTablePropertiesModal } = row;
  const value = row[key];

  return (
    <>
      <Tooltip
        extraLabels={[
          { title: '', subtitle: '' },
          { title: '', subtitle: row[key] },
        ]}
        placement="bottom"
        variant="light"
      >
        <TextField
          size="small"
          fullWidth
          value={value || ''}
          icon={<EllipsisHorizontal />}
          className={classes.field}
          inputProps={{
            readOnly: true,
            className: classes.input,
          }}
          iconProps={{
            onClick: () => handleOpenTablePropertiesModal(key, row),
            size: 'small',
            'ui-ta': getUITA('Modal open button'),
          }}
          ui-ta={getUITA('Extra Prompt Field')}
        />
      </Tooltip>
    </>
  );
};
